import React, { useState } from 'react';
import { Badge, Popover, ActionList, Spinner } from '@shopify/polaris';
import { patchRequest } from '../../../shared/components/functions';

export default function StatusDropdown({ interaction, statuses, onStatusChange }) {
  const [popoverActive, setPopoverActive] = useState(false);
  const [loading, setLoading] = useState(false);

  const currentStatus = statuses.find((s) => s.id === interaction.interaction_status_id);

  const handleStatusChange = async (statusId) => {
    setPopoverActive(false);
    setLoading(true);

    try {
      await patchRequest(`/api/interactions/${interaction.id}/status`, {
        interaction_status_id: statusId
      });
      onStatusChange?.(interaction.id, statusId);
    } catch (error) {
      console.error('Error updating status:', error);
    }

    setLoading(false);
  };

  const activator = (
    <div onClick={() => setPopoverActive(true)} style={{ cursor: 'pointer', display: 'inline-block' }}>
      {loading ? <Spinner size="small" /> : currentStatus ? <Badge tone={currentStatus.color}>{currentStatus.name}</Badge> : <Badge tone="default">No status</Badge>}
    </div>
  );

  const statusOptions = [
    {
      content: 'No status',
      onAction: () => handleStatusChange(null),
      active: !interaction.interaction_status_id
    },
    ...statuses.map((status) => ({
      content: status.name,
      prefix: (
        <Badge tone={status.color} size="small">
          &nbsp;
        </Badge>
      ),
      onAction: () => handleStatusChange(status.id),
      active: status.id === interaction.interaction_status_id
    }))
  ];

  return (
    <Popover active={popoverActive} activator={activator} onClose={() => setPopoverActive(false)} autofocusTarget="first-node">
      <ActionList actionRole="menuitem" items={statusOptions} />
    </Popover>
  );
}
